import { defineComponent as _defineComponent } from 'vue'
import { ref, nextTick, onMounted } from 'vue';
import type { Ref } from 'vue';
import { Icon as PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/CaretCircleLeft.svg';
import '@patsnap-ui/icon/assets/solid/CaretCircleRight.svg';
import { ResizeObserver } from 'vue-resize';
import _ from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'FileWrapperMultiViewTabs',
  props: {
    more: {
        type: Boolean,
        default: false,
    },
    list: {
        type: Array,
        default: () => [],
    },
    value: {
        type: Number,
        default: 1,
    },
},
  emits: ['input'],
  setup(__props, { emit }) {






const isHasScrollbar = ref(false);
const isHasPrev = ref(false);
const isHasNext = ref(false);

const hasScrollButton = (content: HTMLElement) => {
    isHasPrev.value = content.scrollLeft > 0;
    // 可能有小数点误差，所以向上取整。
    isHasNext.value = Math.ceil(content.scrollLeft) < content.scrollWidth - content.clientWidth;
};

const tabsContent:Ref<HTMLElement | undefined> = ref();
const onScrollTabs = (type) => {
    if (tabsContent.value) {
        const currentScrollLeft = tabsContent.value.scrollLeft;
        const distance = type === 'prev' ? -200 : 200;
        const newScrollLeft = currentScrollLeft + distance;
        $(tabsContent.value).animate({
            scrollLeft: newScrollLeft,
        }, 200);
        hasScrollButton(tabsContent.value);
    }
};

const resizeHandler = async () => {
    await nextTick();
    if (tabsContent.value) {
        // scrollWidth是元素的整体宽度。
        // client是可视的宽度
        isHasScrollbar.value = tabsContent.value.scrollWidth > tabsContent.value.clientWidth;
        if (isHasScrollbar.value) {
            hasScrollButton(tabsContent.value);
        }
    }
};

const _resizeHandler = _.debounce(async () => {
    await nextTick();
    if (tabsContent.value) {
        isHasScrollbar.value = tabsContent.value.scrollWidth > tabsContent.value.clientWidth;
        if (isHasScrollbar.value) {
            hasScrollButton(tabsContent.value);
        }
    }
}, 100);

const tabNode = ref<Map<number, any>>(new Map());
const getTabNode = (el:any, id:number) => {
    if (el) {
        tabNode.value.set(id, el);
    }
};

const onSelectTab = (round, index) => {
    window.rvTrack('Change File Wrapper Multi View Round');
    const currentTab = tabNode.value.get(index);
    const tabRect = currentTab?.getBoundingClientRect();

    // 元素不完全在窗口内,则向右滚动citation-map-charts__container
    const tabContainer = document.querySelector('.file-wrapper-multi-view-tabs');
    // @ts-ignore
    const tabRectOffsetWidthRight = _.get(tabRect, 'right', 0) - tabContainer?.offsetWidth || 0;
    const scrollContainer = document.querySelector('.file-wrapper-multi-view-tabs__content');

    if (tabRectOffsetWidthRight > 0) {
        if (scrollContainer) {
            // 加50是+号和数字
            scrollContainer.scrollLeft = scrollContainer.scrollLeft + tabRectOffsetWidthRight + 50;
        }
    }

    const tabRectOffsetWidthLeft = _.get(tabRect, 'left', 0);
    if (tabRectOffsetWidthLeft < 0) {
        if (scrollContainer) {
            // 加50是+号和数字
            scrollContainer.scrollLeft = scrollContainer.scrollLeft + tabRectOffsetWidthLeft - 50;
        }
    }
    emit('input', round);
};

onMounted(async () => {
    resizeHandler();
});


return { __sfc: true,emit, isHasScrollbar, isHasPrev, isHasNext, hasScrollButton, tabsContent, onScrollTabs, resizeHandler, _resizeHandler, tabNode, getTabNode, onSelectTab, PtIcon, ResizeObserver }
}

})